/* eslint-disable react/react-in-jsx-scope */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SignUpProps } from "@/@types/SignUp";
import "react-phone-number-input/style.css";
import ReactPhoneInput from "react-phone-input-material-ui";
import { Form, InputGroup } from "@/components/Form";
import {
  Typography,
  Box,
  Stack,
  Link,
  Checkbox,
  FormControl,
  FormHelperText,
  Card,
  Container,
  TextField,
  useTheme,
} from "@mui/material";
import { LoadingButton as Button } from "@mui/lab";
import { Alert } from "@/components/Modal";
import { IAlertData } from "@/@types/Alert";
import { useAccount, useWalletClient } from "wagmi";
import { useWeb3Modal } from "@web3modal/react";
import { enqueueSnackbar } from "notistack";

const SignUpPage = (props: SignUpProps | null) => {
  const theme = useTheme();
  const nevigate = useNavigate();

  const [isSubmiting, setIsSubmiting] = useState(false);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [firstname, setFirstname] = useState("");
  const [firstnameError, setFirstnameError] = useState("");
  const [lastname, setlastname] = useState("");
  const [lastnameError, setlastnameError] = useState("");
  const { address } = useAccount();
  const { open } = useWeb3Modal();
  const [agree, setAgree] = useState(false);
  const [agreeError, setAgreeError] = useState("");
  const [alertData, setAlertData] = useState<undefined | IAlertData>();
  const signer = useWalletClient();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    let isError = false;
    if (!email) {
      setEmailError("Please enter your email address.");
      isError = true;
    } else {
      setEmailError("");
    }
    if (!phoneNumber) {
      setPhoneNumberError("Please enter your phone number.");
      isError = true;
    } else {
      setPhoneNumberError("");
    }
    if (!firstname) {
      setFirstnameError("Please enter your first name.");
      isError = true;
    } else {
      setFirstnameError("");
    }
    if (!lastname) {
      setlastnameError("Please enter your last name.");
      isError = true;
    } else {
      setlastnameError("");
    }

    if (!address) {
      isError = true;
      await open({ route: "ConnectWallet" });
      return;
    }

    if (agree !== true) {
      setAgreeError("To sign up, you need to agree with conditions.");
      isError = true;
    } else {
      setAgreeError("");
    }
    if (isError) {
      return;
    }

    setIsSubmiting(true);
    try {
      if (props && address) {
        await props.userStore.signUp({
          email,
          firstname,
          lastname,
          phoneNumber: "+" + phoneNumber,
          username: email,
          wallet_address: address,
        });
        setAlertData({
          message:
            "Sign up successful! Please check your email (it may be in the spam folder) for the verification email.",
          button: {
            text: "Sign In",
            method: () => {
              nevigate("/sign-in");
            },
          },
        });
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      const errorMessage = e.raw.message;
      if (
        errorMessage ===
        'pq: duplicate key value violates unique constraint "users_email_key"'
      ) {
        enqueueSnackbar("This email has already been used.", {
          variant: "error",
        });
      } else if (
        errorMessage ===
        'pq: duplicate key value violates unique constraint "users_username_key"'
      ) {
        enqueueSnackbar("This username has already been used.", {
          variant: "error",
        });
      } else if (
        errorMessage ===
        'pq: duplicate key value violates unique constraint "users_phone_number_key"'
      ) {
        enqueueSnackbar("This phone number has already been used.", {
          variant: "error",
        });
      } else if (
        errorMessage ===
        'pq: duplicate key value violates unique constraint "users_wallet_address_key"'
      ) {
        enqueueSnackbar("This wallet address has already been used.", {
          variant: "error",
        });
      } else if (
        errorMessage.includes("pq: value too long for type character varying")
      ) {
        const startIndex = errorMessage.indexOf("(");
        const endIndex = errorMessage.indexOf(")");

        enqueueSnackbar(
          `Please enter a phone number that is no more than ${errorMessage.slice(
            startIndex + 1,
            endIndex,
          )} digits long.(include "+" and country code)`,
          { variant: "error" },
        );
      } else {
        enqueueSnackbar("Something went wrong.", { variant: "error" });
        console.error(e.raw.message);
      }
    }
    setIsSubmiting(false);
  };
  useEffect(() => {
    if (signer.isIdle) {
      open();
    }
  }, [signer.isIdle, open]);

  return (
    <Container
      maxWidth="sm"
      sx={{
        py: "82px",
        [theme.breakpoints.up("lg")]: { maxWidth: "sm", py: "82px" },
      }}
    >
      <Card
        sx={{
          maxWidth: "670px",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <Typography variant="h2">Sign Up</Typography>
        <Form
          onSubmit={handleSubmit}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          <TextField
            type="email"
            name="email"
            fullWidth
            id="email"
            error={emailError != ""}
            label="Email"
            value={email}
            helperText={emailError}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            type="text"
            name="Firstname"
            fullWidth
            id="Firstname"
            error={firstnameError != ""}
            label="Firstname"
            value={firstname}
            helperText={firstnameError}
            onChange={(e) => setFirstname(e.target.value)}
          />
          <TextField
            type="text"
            name="Lastname"
            fullWidth
            id="Lastname"
            error={lastnameError != ""}
            label="Lastname"
            value={lastname}
            helperText={lastnameError}
            onChange={(e) => setlastname(e.target.value)}
          />
          <InputGroup>
            <ReactPhoneInput
              country={"th"}
              enableAreaCodes={true}
              enableSearch={true}
              autocompleteSearch
              placeholder="Enter phone number"
              value={phoneNumber}
              defaultErrorMessage="Invalid phone number"
              onChange={(e) => setPhoneNumber(e)}
              component={TextField}
            />
            <FormHelperText error={phoneNumberError != ""}>
              {phoneNumberError}
            </FormHelperText>
          </InputGroup>
          <Typography variant="body2">My wallet address: {address}</Typography>
          <FormControl
            required
            error={!!agreeError}
            sx={{ width: "100%", mb: "3rem" }}
          >
            <Stack
              direction="row"
              gap="0.3525rem"
              justifyContent="center"
              alignItems="center"
            >
              <Checkbox
                name="agree"
                checked={agree}
                color="primary"
                onChange={(e) => setAgree(e.target.checked)}
              />
              <Typography variant="body2">
                I agree to {""}
                {/* TODO: add link to agreement */}
                <Link
                  href="#/terms"
                  target="_blank"
                  underline="none"
                  rel="noopener"
                >
                  Terms of Service
                </Link>
                {""} and {""}
                <Link
                  href="#/privacy"
                  target="_blank"
                  underline="none"
                  rel="noopener"
                >
                  Privacy Policy
                </Link>
              </Typography>
            </Stack>
            <FormHelperText>{agreeError}</FormHelperText>
          </FormControl>
          <Box width="fit-content" mx="auto">
            <Button
              loading={isSubmiting}
              variant="contained"
              size="large"
              type="submit"
            >
              Sign Up
            </Button>
          </Box>
        </Form>
        {alertData && (
          <Alert
            alertData={{ ...alertData, containerSx: { px: "5.375rem" } }}
          />
        )}
      </Card>
    </Container>
  );
};

export default SignUpPage;
